import React from 'react'
// import {BrowserRouter as Router, Route} from "react-router-dom";
// import HomePhones from '../Pages/HomePhones'

export default function Navbar() {
    return (
        <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <a class="navbar-item" href="/">
                    <h2 className="h2-title">OH.</h2>
                    {/* <img alt="Logo" src="https://images.ctfassets.net/5gv1edeicqfs/bomBQDobMA6eyu4CkuYmM/6f5debe74cf1e335bb0be7e3ecbba40b/gs-logo.png" width="112" height="28"/> */}
                </a>
            </div>

            <div id="navbarBasicExample" class="navbar-menu">
                <div class="navbar-start">
                    <a href="/" class="navbar-item">
                        Home
                    </a>

                    <a href="/" class="navbar-item">
                        Example button
                    </a>
                </div>
            </div>
        </nav>   
    )
}
